import ar from '../locales/ar.json'

const PHONE_REGEX   = /^[+]?[\d\s\-().]{7,20}$/
const YEAR_REGEX    = /^(19|20)\d{2}$/

// ----------------------------------------------------------------
// Validation per step
// ----------------------------------------------------------------
export function validateStep(step, formData, files) {
  const errors = {}
  const t = ar.validation

  switch (step) {
    case 1: {
      if (!formData.name_applicant?.trim())   errors.name_applicant   = t.required
      if (!formData.relation_applicant)       errors.relation_applicant = t.required
      if (!formData.phone_primary?.trim())    errors.phone_primary    = t.required
      else if (!PHONE_REGEX.test(formData.phone_primary)) errors.phone_primary = t.phone
      if (formData.phone_secondary && !PHONE_REGEX.test(formData.phone_secondary))
        errors.phone_secondary = t.phone
      break
    }

    case 2: {
      if (!formData.martyr_fullname?.trim())    errors.martyr_fullname    = t.required
      if (!formData.mother_name?.trim())        errors.mother_name        = t.required
      if (!formData.current_residence?.trim())  errors.current_residence  = t.required
      if (!formData.civil_registry_place?.trim()) errors.civil_registry_place = t.required
      if (!formData.marital_status)             errors.marital_status     = t.required
      if (formData.birth_date && !/^\d{4}(-\d{2}(-\d{2})?)?$/.test(formData.birth_date))
        errors.birth_date = t.date
      break
    }

    case 3: {
      if (!formData.incident_type)  errors.incident_type = t.required
      const fileErrors = validateFiles(files?.evidence_upload || [])
      if (fileErrors) errors.evidence_upload = fileErrors
      break
    }

    case 4: {
      if (!formData.has_witnesses) errors.has_witnesses = t.required
      if (formData.has_witnesses === 'نعم') {
        formData.witnesses.forEach((w, i) => {
          if (!w.witness_name?.trim())  errors[`witness_name_${i}`]  = t.required
          if (!w.witness_role)          errors[`witness_role_${i}`]  = t.required
        })
      }
      break
    }

    case 5: {
      if (!formData.case_contact_person?.trim())  errors.case_contact_person  = t.required
      if (!formData.contact_primary_phone?.trim()) errors.contact_primary_phone = t.required
      else if (!PHONE_REGEX.test(formData.contact_primary_phone))
        errors.contact_primary_phone = t.phone
      if (formData.contact_secondary_phone && !PHONE_REGEX.test(formData.contact_secondary_phone))
        errors.contact_secondary_phone = t.phone
      break
    }

    case 6: {
      if (!formData.region)       errors.region    = t.mustSelectRegion
      if (!formData.neighborhood) errors.neighborhood = t.mustSelectNeighborhood
      if (!formData.affiliationDeclaration) errors.affiliationDeclaration = t.declarationRequired
      if (!formData.final_signature?.trim()) errors.final_signature = t.signatureRequired
      if (!formData.final_date)   errors.final_date = t.required
      break
    }
  }

  return errors
}

export function validateFiles(fileList) {
  const ALLOWED = ['image/jpeg', 'image/png', 'application/pdf', 'video/mp4']
  const MAX_PER_FILE   = 10 * 1024 * 1024   // 10 MB
  const MAX_TOTAL      = 50 * 1024 * 1024   // 50 MB

  let total = 0
  for (const f of fileList) {
    if (!ALLOWED.includes(f.type)) return ar.validation.fileType
    if (f.size > MAX_PER_FILE)     return ar.validation.fileTooLarge
    total += f.size
  }
  if (total > MAX_TOTAL) return ar.validation.totalFilesTooLarge
  return null
}

export function hasErrors(errors) {
  return Object.values(errors).some(Boolean)
}

export function isYearValid(y) {
  return YEAR_REGEX.test(String(y))
}
